import React, { useState } from 'react';
import {
    Grid,
    Stepper,
    Step,
    StepLabel,
    Typography,
    Avatar,
    Popover,
    Icon,
    useTheme,
} from '../../../base';
import { IStepData, JobApplicationStatusUpdateValues } from '../../../common';
import CustomStepIcon from './CustomStepIcon';
import { StepConnector } from './Stepper.styles.ts';
import { useTranslation } from 'react-i18next';

// Main Component
interface Props {
    steps: Array<IStepData>;
}

const CustomStepper = (props: Props) => {
    const { steps } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [activeStep, setActiveStep] = useState<number | null>(null);

    const handlePopoverOpen = (
        event: React.MouseEvent<HTMLElement>,
        index: number
    ) => {
        setAnchorEl(event.currentTarget);
        setActiveStep(index);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        setActiveStep(null);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ overflowX: 'auto' }}>
                <Stepper alternativeLabel connector={<StepConnector />} sx={{ minWidth: 'max-content' }}>
                    {steps.map((step, index) => (
                        <Step
                            key={step.id}
                            completed={
                                step.status ===
                                    JobApplicationStatusUpdateValues.accept ||
                                step.status ===
                                    JobApplicationStatusUpdateValues.reject
                            }
                            onMouseEnter={(e) => handlePopoverOpen(e, index)}
                            onMouseLeave={handlePopoverClose}
                        >
                            <StepLabel
                                StepIconComponent={() => (
                                    <CustomStepIcon
                                        status={step.status}
                                        users={step.users}
                                    />
                                )}
                            >
                                <Typography
                                    variant="caption"
                                    style={{
                                        color: theme.palette.grey[600],
                                    }}
                                >
                                    {step.name}
                                </Typography>
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Grid>
            {/* <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                style={{
                    pointerEvents: 'none',
                }}
            >
                {activeStep !== null && (
                    <Grid
                        container
                        spacing={1}
                        style={{ padding: 16, maxWidth: 300 }}
                    >
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                {t('jobApplicationPage.stepParticipants')}
                            </Typography>
                        </Grid>
                        {steps[activeStep].users.map((user) => (
                            <Grid
                                item
                                xs={12}
                                key={`${user.id}_${steps[activeStep].id}`}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                }}
                            >
                                <Avatar
                                    src={user.avatar}
                                    alt={user.name}
                                    name={user.name}
                                    style={{ width: 24, height: 24 }}
                                />
                                <Typography variant="body2">
                                    {user.name}
                                </Typography>
                                {user.isOwner && (
                                    <Typography
                                        variant="caption"
                                        style={{
                                            marginLeft: 8,
                                            color: 'text.secondary',
                                        }}
                                    >
                                        (Owner)
                                    </Typography>
                                )}
                                {user.decision && (
                                    <div style={{ marginLeft: 'auto' }}>
                                        {user.decision === 'pass' ? (
                                            <Icon
                                                name={'CheckRoundedIcon'}
                                                size={16}
                                                color={
                                                    theme.palette.success.main
                                                }
                                            />
                                        ) : (
                                            <Icon
                                                name={'CloseRoundedIcon'}
                                                size={16}
                                                color={theme.palette.error.main}
                                            />
                                        )}
                                    </div>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Popover> */}
        </Grid>
    );
};

export default CustomStepper;
